var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("div", { staticClass: "common-title" }, [_vm._v("贸易列表")]),
      _vm._v(" "),
      _c("a-table", {
        attrs: {
          size: "middle",
          columns: _vm.columns,
          "row-key": function(record) {
            return record.id
          },
          "data-source": _vm.tableDataInv,
          pagination: _vm.pagination,
          loading: _vm.loading,
          bordered: "",
          locale: { emptyText: "暂无数据" },
          "row-selection": _vm.tableSelect,
          scroll: {}
        },
        on: { change: _vm.handleTableChange },
        scopedSlots: _vm._u([
          {
            key: "invoiceType",
            fn: function(text) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("invoiceTypeFilter")(text)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "invoiceNumber",
            fn: function(text, record) {
              return [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.toInvoiceInfo(record)
                      }
                    }
                  },
                  [_vm._v(_vm._s(text))]
                )
              ]
            }
          },
          {
            key: "billTime",
            fn: function(text) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "invoiceAmountWithVat",
            fn: function(text) {
              return [
                _vm._v("\n      " + _vm._s(_vm._f("splitK")(text)) + "\n    ")
              ]
            }
          },
          {
            key: "contractNo",
            fn: function(text, record) {
              return [
                text
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.contractInfoOpen(record)
                          }
                        }
                      },
                      [_vm._v(_vm._s(text))]
                    )
                  : _c("span", [_vm._v("--")])
              ]
            }
          },
          {
            key: "otherFile",
            fn: function(text, record) {
              return [
                record.uploaded
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.toDeliveryCreate(record)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  : _c("span", [_vm._v("--")])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceInfo",
        attrs: { readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("contractDialog", {
        ref: "contractInfo",
        attrs: { title: "匹配合同详情", readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("relatedFileDialog", { ref: "relatedFileDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d5e0956", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5e0956","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/gold-financing/gold-financing-steps/gold-financing-step2.vue
// module id = NRHm
// module chunks = 1